import {
  Box,
  Collapse,
  ListItemButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { Down, Up } from "assets/Icon";
import React, { useState } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";
import { useSearchParams } from "react-router-dom";
import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import { VALUE_BALANCE } from "pages/Wallet/constants";

function CoinItem({ coin, valueBalance }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 1;

  const handleClick = () => {
    setOpen((v) => !v);
  };

  return (
    <>
      <ListItemButtonStyle onClick={handleClick} open={open}>
        <CoinNameWrapper>
          <img src={DefaultUrlWeb + coin?.coinImageUrl} alt="" />

          <Typography color={open ? "secondary" : "text.main"} variant="h6">
            {coin?.coinName}
          </Typography>
        </CoinNameWrapper>

        <CoinPriceWrapper>
          <Typography
            color={open ? "secondary" : "text.main"}
            variant="h6"
            sx={{ mr: 0.5 }}
          >
            <NumberFormats value={coin?.availableBalance} />
          </Typography>

          {open ? (
            <Up color={theme.palette.secondary.main} />
          ) : (
            <Down color={theme.palette.text.main} />
          )}
        </CoinPriceWrapper>
      </ListItemButtonStyle>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <CoinDetailWrapper>
          {coin?.tradeLimit ||
          (coin?.tradeLimit === 0 && walletTypeId === WALLET_TYPE.spot) ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Limit:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.tradeLimit || 0} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {/* {coin?.locked || coin?.locked === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Locked:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.locked || 0} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )} */}

          {coin?.borrowed || coin?.borrowed === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Borrowed:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.borrowed || 0} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {coin?.interest || coin?.interest === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Interest:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.interest || 0} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {coin?.equityValue || coin?.equityValue === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Equity:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.equityValue} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {coin?.totalBalance || coin?.totalBalance === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Total:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.totalBalance} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {valueBalance !== VALUE_BALANCE.USDT &&
          (coin?.totalBalanceToman || coin?.totalBalanceToman === 0) ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Value Blnc:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.totalBalanceToman} />{" "}
                <Typography
                  variant="subtitle1"
                  component="span"
                  color="text.secondary"
                  pl={0.5}
                >
                  Toman
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {valueBalance === VALUE_BALANCE.USDT &&
          (coin?.totalBalanceUSDT || coin?.totalBalanceUSDT === 0) ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Value Blnc:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.totalBalanceUSDT} />
                <Typography
                  variant="subtitle1"
                  component="span"
                  color="text.secondary"
                  pl={0.5}
                >
                  USDT
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {valueBalance !== VALUE_BALANCE.USDT &&
          (coin?.equityValueToman || coin?.equityValueToman === 0) ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Equity Blnc:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.equityValueToman} />
                <Typography
                  variant="subtitle1"
                  component="span"
                  color="text.secondary"
                  pl={0.5}
                >
                  Toman
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}

          {valueBalance === VALUE_BALANCE.USDT &&
          (coin?.equityValueUSDT || coin?.equityValueUSDT === 0) ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Equity Blnc:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.equityValueUSDT} />
                <Typography
                  variant="subtitle1"
                  component="span"
                  color="text.secondary"
                  pl={0.5}
                >
                  USDT
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}
        </CoinDetailWrapper>
      </Collapse>
    </>
  );
}

const ListItemButtonStyle = styled(ListItemButton)(({ theme, open }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  transition: "all 0.3s",
  padding: theme.spacing(1),
  borderTop: `1px solid ${
    open ? theme.palette.secondary.main : theme.palette.modules.border
  }`,
}));

const CoinNameWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    marginRight: theme.spacing(1),
  },
}));

const CoinPriceWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const CoinDetailWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.blueBottomToTopGradient,
  padding: theme.spacing(1, 0.5, 0.5),
}));

export default CoinItem;
